import { render, staticRenderFns } from "./CustomerOrderInformation.vue?vue&type=template&id=2b36287e&scoped=true&"
import script from "./CustomerOrderInformation.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderInformation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderInformation.vue?vue&type=style&index=0&id=2b36287e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36287e",
  null
  
)

export default component.exports